import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export type Content = {
  src: string;
  html: string;
  label: string;
  isHTML: boolean;
  showLabel: boolean;
  isInvoice?: boolean;
  isVideo?: boolean;
  isPdf?: boolean;
  /**
   * Optional image gallery: with more than one item the preview shows
   * previous/next arrows (and takes the arrow keys); `index` is the one open.
   */
  items?: Array<{ src: string; label: string }>;
  index?: number;
};

@Injectable({
  providedIn: 'root',
})
export class FullScreenPreviewService {
  constructor() {}

  private isPreviewOpen = new BehaviorSubject<boolean>(false);

  private content = new BehaviorSubject<Content>({
    src: '',
    html: '',
    label: '',
    isHTML: false,
    showLabel: false,
    isInvoice: false,
    isVideo: false,
    isPdf: false,
  });

  openPreview(): void {
    this.isPreviewOpen.next(true);
  }
  closePreview(): void {
    this.isPreviewOpen.next(false);
  }
  getIsPreviewOpen(): Observable<boolean> {
    return this.isPreviewOpen.asObservable();
  }
  getContent(): Observable<Content> {
    return this.content.asObservable();
  }
  setContent(content: Content): void {
    this.content.next(content);
  }
}
